import { z } from "zod";

/// URL search-params schema for `/$slug/one-on-ones`.
///
/// Two scopes only. The design handoff's as_manager / as_report split and
/// the archived tab died with the inbox list: the relationship dashboard
/// groups by hierarchy edge itself, and cancelled instances live in the
/// per-person history view.
///
///   all       , the personal relationship dashboard; default.
///   workspace , every 1:1 in the workspace (admins, instance ledger).
///
/// Tab visibility is gated in the toolbar (admins-only for `workspace`)
/// AND at the route (refuse-by-redirect) per the scope-tabs convention.
export const ONE_ON_ONE_SCOPES = ["all", "workspace"] as const;
export type OneOnOneScope = (typeof ONE_ON_ONE_SCOPES)[number];

export function isPersonalScope(scope: OneOnOneScope): scope is "all" {
  return scope !== "workspace";
}

export const oneOnOneRouteSearchSchema = z
  .object({
    scope: z.enum(ONE_ON_ONE_SCOPES).catch("all").default("all"),
    /// Legacy relationship-board deep link; the route redirects it to the
    /// per-person history view. `counterpartName` labels that view's header.
    counterpartId: z.string().optional(),
    counterpartName: z.string().optional(),
  })
  .strict();
export type OneOnOneRouteSearch = z.infer<typeof oneOnOneRouteSearchSchema>;
